import { type RunHandle, type Runner, type RunRequest, startRun } from "@codeshare/runner-core";

export { GO_VERSION } from "./version";

/**
 * Runs Go with the real toolchain: the program is compiled and linked to WASM in a worker, then
 * run. The compiler, linker and standard library download on first use.
 */
export const goRunner: Runner = {
  id: "go",
  name: "Go",
  tests: "go test: TestXxx(t *testing.T) functions in _test.go files",
  run(request: RunRequest, options: { timeoutMs?: number } = {}): RunHandle {
    return startRun({
      createWorker: () =>
        new Worker(new URL("./go.worker.ts", import.meta.url), { type: "module" }),
      request,
      ...options,
    });
  },
};
